import _objectSpread from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://m.media-amazon.com/images/G/28/NewApp/00_EN/Landingpage_Searchbox.png"
}, null, -1);
var _hoisted_2 = ["onClick"];
import { ref, onMounted } from 'vue';
import 'swiper/swiper-bundle.css';
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { useLess } from '@/models/hooks';
import { jumpInteractionType } from '@/utils/common';
import { useRoute, useRouter } from 'vue-router';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
var IMAGE_WIDTH_DEFAULT = 375;
export default {
  __name: 'MapArea',
  props: {
    properties: {
      // Component configuration information, received from parent component
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  setup(__props) {
    var props = __props;
    var route = useRoute();
    var router = useRouter();
    useLess('views/landingPage/mapArea/MapArea.less');
    SwiperCore.use([Pagination, Navigation, Autoplay]);
    var carouselInfos = ref();
    // page dom
    var mapAreaRef = ref(null);
    // get mapArea Style
    var getMapAreaStyle = (mapArea = {}) => {
      var style = {};
      if (mapAreaRef.value) {
        var domWidth = mapAreaRef.value && mapAreaRef.value.offsetWidth;
        var imgScale = domWidth / IMAGE_WIDTH_DEFAULT;
        style = {
          width: `${(mapArea.elementPositionX || 0) * imgScale - (mapArea.mouseDownX || 0) * imgScale}px`,
          height: `${(mapArea.elementPositionY || 0) * imgScale - (mapArea.mouseDownY || 0) * imgScale}px`,
          top: `${(mapArea.mouseDownY || 0) * imgScale}px`,
          left: `${(mapArea.mouseDownX || 0) * imgScale}px`
        };
      }
      return style;
    };
    onMounted(() => {
      carouselInfos.value = props.properties.carouselInfos;
      var recordParams = {
        pageName: route.name
      };
      awsRumHandler.recordClickEvent(_objectSpread(_objectSpread({}, clickEvents.landingPage.mapAreaWidget), recordParams));
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["map-area", {
          'map-area-card': __props.properties.presentationType === 'THREE_IMENSIONAL'
        }]),
        ref_key: "mapAreaRef",
        ref: mapAreaRef,
        style: _normalizeStyle([{
          paddingBottom: `${__props.properties.bottomSpacing}px`
        }])
      }, [_createVNode(_unref(Swiper), {
        pagination: true,
        modules: [_unref(Pagination), _unref(Navigation), _unref(Autoplay)],
        loop: __props.properties.circulateType === 'LOOP',
        autoplay: __props.properties.slideType === 'AUTOMATIC' ? {
          delay: Number(__props.properties.swipeTime * 1000),
          disableOnInteraction: false
        } : false
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(carouselInfos.value, item => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            key: item.id
          }, {
            default: _withCtx(() => [_hoisted_1, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.interactionTypeInfo, mapArea => {
              return _openBlock(), _createElementBlock("span", {
                key: mapArea,
                style: _normalizeStyle(getMapAreaStyle(mapArea)),
                onClick: $event => _unref(jumpInteractionType)(mapArea, _unref(router)),
                class: "map-area-box"
              }, null, 12, _hoisted_2);
            }), 128))]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 8, ["modules", "loop", "autoplay"])], 6);
    };
  }
};